// services/categorieService.js
import axiosInstance from '../axiosConfig'

const API_URL = process.env.REACT_APP_API_URL;

const categorieService = {
  getCategories: async () => {
    try {
      const response = await axiosInstance.get(`${API_URL}/categories`, {withCredentials: true});
      return response.data;
    } catch (error) {
      console.error('Error fetching categories', error);
      throw error;
    }
  },

  getCategorieById: async (id) => {
    try {
      const response = await axiosInstance.get(`${API_URL}/categories/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching categories', error);
      throw error;
    }
  },

  createCategorie: async (cat) => {
    try {
      const response = await axiosInstance.post(`${API_URL}/categories`, cat);
      return response.data;
    } catch (error) {
      console.error('Error creating categories', error);
      throw error;
    }
  },

  updateCategorie: async (id, cat) => {
    try {
      const response = await axiosInstance.put(`${API_URL}/categories/${id}`, cat);
      return response.data;
    } catch (error) {
      console.error('Error updating categories', error);
      throw error;
    }
  },

  deleteCategorie: async (id) => {
    try {
      const response = await axiosInstance.delete(`${API_URL}/categories/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting categories', error);
      throw error;
    }
  },
};

export default categorieService;
